module.exports = __webpack_public_path__ + "static/media/user.affc1aa9.jfif";